<template>
  <div class="space-y-3.5">
    <template v-for="(block, index) in contentBlocks" :key="index">
      <h3
        v-if="block.type === 'heading' && block.level === 2"
        class="pt-4 first:pt-0 text-[15px] font-semibold tracking-tight leading-snug"
      >{{ block.text }}</h3>

      <h4
        v-else-if="block.type === 'heading'"
        class="pt-2 text-[13.5px] font-semibold leading-snug"
      >{{ block.text }}</h4>

      <p
        v-else-if="block.type === 'paragraph'"
        class="text-[13.5px] leading-relaxed text-[hsl(var(--foreground)/0.86)] whitespace-pre-line"
      ><LegalInlineText :text="block.text" /></p>

      <ul v-else-if="block.type === 'list'" class="space-y-1.5 pl-5">
        <li
          v-for="(item, itemIndex) in block.items"
          :key="itemIndex"
          class="text-[13.5px] leading-relaxed text-[hsl(var(--foreground)/0.86)] list-disc"
        ><LegalInlineText :text="item" /></li>
      </ul>

      <div v-else-if="block.type === 'table'">
        <div class="hidden sm:block overflow-x-auto rounded-xl border border-[hsl(var(--border))]">
          <table class="w-full min-w-[32rem] text-[12.5px] border-collapse">
            <thead v-if="block.headers.some(Boolean)">
              <tr class="bg-[hsl(var(--muted)/0.6)]">
                <th
                  v-for="(header, headerIndex) in block.headers"
                  :key="headerIndex"
                  class="text-left font-semibold px-3 py-2.5 border-b border-[hsl(var(--border))]"
                >{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, rowIndex) in block.rows"
                :key="rowIndex"
                class="border-b border-[hsl(var(--border)/0.6)] last:border-b-0"
              >
                <td
                  v-for="(cell, cellIndex) in row"
                  :key="cellIndex"
                  class="px-3 py-2.5 align-top whitespace-pre-line"
                  :class="cellIndex === 0 ? 'font-semibold' : 'text-[hsl(var(--foreground)/0.82)]'"
                ><LegalInlineText :text="cell" /></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="sm:hidden rounded-xl border border-[hsl(var(--border))] divide-y divide-[hsl(var(--border)/0.6)]">
          <div v-for="(row, rowIndex) in block.rows" :key="rowIndex" class="px-3 py-3">
            <p class="text-[12.5px] font-semibold whitespace-pre-line"><LegalInlineText :text="row[0] ?? ''" /></p>
            <p
              v-for="(cell, cellIndex) in row.slice(1)"
              :key="cellIndex"
              class="mt-1 text-[12px] leading-relaxed text-[hsl(var(--foreground)/0.76)] whitespace-pre-line"
            ><LegalInlineText :text="cell" /></p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { parseLegalMarkdown } from "../utils/legalMarkdown";
import LegalInlineText from "./LegalInlineText.vue";

const props = defineProps<{ markdown: string }>();

const contentBlocks = computed(() => parseLegalMarkdown(props.markdown).blocks.filter(
  (block) => !(block.type === "heading" && block.level === 1) && block.type !== "revision",
));
</script>
